// extracted by mini-css-extract-plugin
export var actions = "_4j-0";
export var actionsContainer = "_4j-7";
export var border = "_4j-1";
export var childFullHeight = "_4j-f";
export var collapse = "_4j-2";
export var content = "_4j-a";
export var contentChild = "_4j-e";
export var fullscreen = "_4j-c";
export var hasLeftRadius = "_4j-k";
export var headerContainer = "_4j-3";
export var headerRow = "_4j-5";
export var hidePadding = "_4j-b";
export var navCollapsedGap = "_4j-l";
export var noScrollX = "_4j-m";
export var noScrollY = "_4j-n";
export var noTopPadding = "_4j-i";
export var optOutTopPadding = "_4j-d";
export var pageMain = "_4j-j";
export var pageOuter = "_4j-g";
export var pagePadding = "_4j-8";
export var pageScroll = "_4j-9";
export var profile = "_4j-o";
export var profileContainer = "_4j-p";
export var profileImage = "_4j-q";
export var profileMain = "_4j-r";
export var profileSubtitle = "_4j-t";
export var profileTitle = "_4j-s";
export var showLeftPadding = "_4j-h";
export var tabsPortalSlot = "_4j-6";
export var tabsWrapper = "_4j-4";
export var title = "_4j-u";